import { getItem, formatShortDate } from '../utils';

/**
 * API service layer for Manage Items
 */

export const fetchEntityList = async ({ entity, date = new Date(), userEmail }) => {
  const payload = {
    action: entity.listAction,
    type: 'list',
    condition: formatShortDate(date, 'unformated'),
    user: userEmail
  };

  const response = await getItem(payload);
  if (!response) {
    throw new Error(`Failed to fetch ${entity.name || entity.listAction}`);
  }
  if (!Array.isArray(response)) {
    if (response.error) {
      throw new Error(response.error);
    }
    return [];
  }
  return response;
};

export const addEntity = async ({ entity, itemData }) => {
  if (!entity.addAction) {
    throw new Error(`Adding is not supported for ${entity.name || entity.listAction}`);
  }

  const payload = {
    action: entity.addAction,
    items: itemData
  };

  const response = await getItem(payload);
  if (!response || !response.success) {
    throw new Error(response?.error || 'Failed to add item');
  }
  return response;
};

export const editEntityField = async ({ entity, conditionValue, field, value, date = new Date() }) => {
  const payload = {
    action: 'edit-item',
    listType: entity.listAction,
    conditionKey: entity.conditionKey,
    conditionValue,
    date: formatShortDate(date, 'unformated'),
    [field]: value
  };

  const response = await getItem(payload);
  if (!response || !response.success) {
    throw new Error(response?.error || 'Failed to update item');
  }
  return response;
};

export const deleteEntity = async ({ entity, id, userEmail }) => {
  const payload = {
    action: 'ta-bort',
    email: userEmail,
    listType: entity.listAction,
    conditionValue: id
  };

  const response = await getItem(payload);
  if (!response || !response.success) {
    throw new Error(response?.error || 'Failed to delete item');
  }
  return response;
};

export const fetchPriceGroupOptions = async () => {
  const response = await getItem({ action: 'get-object-price-names' });
  return response || [];
};

export const fetchMemberTypeNames = async () => {
  const response = await getItem({ action: 'get-member-type-names' });
  return response || [];
};
